// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TicketAttachment-wrap","imageIcon":"TicketAttachment-imageIcon","name":"TicketAttachment-name","closeIcon":"TicketAttachment-closeIcon"};